import { createBrowserRouter, Navigate } from 'react-router-dom';
import AdminLayout from './components/layout/AdminLayout';
import Dashboard from './pages/Dashboard';
import JourneyList from './pages/journeys/JourneyList';
import JourneyEdit from './pages/journeys/JourneyEdit';
import SpotlightList from './pages/spotlight/SpotlightList';
import SpotlightEdit from './pages/spotlight/SpotlightEdit';
import PageList from './pages/pages/PageList';
import PageEdit from './pages/pages/PageEdit';
import MediaPage from './pages/media/MediaPage';
import BookingList from './pages/bookings/BookingList';
import BookingView from './pages/bookings/BookingView';
import SettingsPage from './pages/settings/SettingsPage';
import FAQList from './pages/faqs/FAQList';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AdminLayout />,
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: 'dashboard', element: <Dashboard /> },

      // Journeys
      { path: 'journeys', element: <JourneyList /> },
      { path: 'journeys/new', element: <JourneyEdit /> },
      { path: 'journeys/:id', element: <JourneyEdit /> },

      // Spotlight
      { path: 'spotlight', element: <SpotlightList /> },
      { path: 'spotlight/new', element: <SpotlightEdit /> },
      { path: 'spotlight/:id', element: <SpotlightEdit /> },

      // Pages
      { path: 'pages', element: <PageList /> },
      { path: 'pages/:id', element: <PageEdit /> },

      // FAQs
      { path: 'faqs', element: <FAQList /> },

      // Media
      { path: 'media', element: <MediaPage /> },

      // Bookings
      { path: 'bookings', element: <BookingList /> },
      { path: 'bookings/:id', element: <BookingView /> },

      // Settings
      { path: 'settings', element: <SettingsPage /> },
    ],
  },
]);
